export default {
  'areas.maintitle': 'Management area',
  'areas.create': 'Create new area',
  'areas.update': 'Update area',
  'areas.infomation': 'Area information',

  'areas.areaslist': 'List of areas',

  'areas.provinceCodes': 'Dependent provinces',
  'areas.action': 'Action',
  'areas.totalLocation': 'Total locations',

  'areas.name': 'Area name',
  'areas.name.placeholder': 'Please enter area name ',
  'areas.description': 'Description',
  'areas.description.placeholder': 'Please enter description',
  'areas.provinces': 'Dependent provinces',
  'areas.selectProvinces.placeholder': 'Please select dependent provinces',

  'areas.add': 'Add',
  'areas.edit': 'Update',
  'areas.cancel': 'Cancel',

  'areas.deleteconfirm': 'Can you confirm deleting this area?',
};
